import { userConstants } from '../_constants';

let user = null;
try {
    const userData = sessionStorage.getItem('user');
    user = userData ? JSON.parse(userData) : null;
} catch (error) {
    console.error('Error parsing user data from sessionStorage:', error);
    sessionStorage.removeItem('user'); // Clear corrupted data
}

const initialState = user ? { loggedIn: true, user } : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: false
      };
    case userConstants.LOGIN_SUCCESS:      
      return {
        loggedIn: true,
        user: action.successAction.user
      };
    case userConstants.LOGIN_FAILURE:
      return {};
    case userConstants.LOGOUT:
      return {};
    default:
      return state
  }
}